export const vendorDetailsColumns = [
  {
    key: "name",
    label: "Name",
  },  
  ];
